import { gql } from '../__generated__';

const RenewalItem = gql(`
  fragment RenewalModelItem on RenewalModel {
    id
    licenseId
    name
    subscriptionOrderNumber
    bfs
    bfsp
    bfsb
    bfsf
    bfsu
    bvn
    total
  }
`);

export const GET_RENEWALS_AT = gql(`
  query GetRenewalsAt($month: Int!, $year: Int!, $at: DateTimeOffset!) {
    renewals: getRenewalsAt(month: $month, year: $year, at: $at) {
      ...RenewalModelItem
    }
  }
`);

export const GET_RENEWALS_MACONOMY = gql(`
  query GetRenewalsMaconomy($month: Int!, $year: Int!) {
    renewals: getRenewalsFromMaconomy(month: $month, year: $year) {
      ...RenewalModelItem
    }
  }
`);
